import * as React from "react";

import {
	Edit,
	SimpleForm,
	EditProps,
	BooleanInput,
	TextInput,
	ReferenceInput,
	SelectInput,
	ResourceContextProvider,
	Toolbar,
	SaveButton,
	DeleteButton,
	ListToolbar,
} from "react-admin";

import { DoctorSaleTitle } from "../doctorSale/DoctorSaleTitle";
import labelsTranslation from "../translations/tranlation";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles({
	toolbar: {
		display: "flex",
		justifyContent: "space-between",
	},
});

const CustomToolbar = (props) => (
	<Toolbar {...props} classes={useStyles()}>
		<SaveButton />
		{/* <DeleteButton undoable={false} /> */}
	</Toolbar>
);

export const PatientEdit = (props) => {
	return (
		<ResourceContextProvider value="Patient">
			<Edit title={labelsTranslation.userEdit.title} {...props}>
				<SimpleForm toolbar={<CustomToolbar />}>
					{/* <TextInput
						label={labelsTranslation.userCreate.comment}
						multiline
						source="doctorComment"
					/> */}
					<TextInput
						label="توضیحات اپراتور"
						multiline
						minRows={5}
						source="saleRepresentativeComment"
					/>
					<BooleanInput label="آرشیو" source="archived" />
					{/* <TextInput
						label={labelsTranslation.userCreate.fName}
						source="firstName"
					/>
					<TextInput
						label={labelsTranslation.userCreate.lName}
						source="lastName"
					/>
					<TextInput
						label={labelsTranslation.userCreate.mobile}
						source="mobile"
					/> */}

					{/* <TextInput label="Doctor Id" source="doctorId" />
				<ReferenceInput
					source="doctorsale.id"
					reference="DoctorSale"
					label="Doctor Sale"
				>
					<SelectInput optionText={DoctorSaleTitle} />
				</ReferenceInput> */}
				</SimpleForm>
			</Edit>
		</ResourceContextProvider>
	);
};
